{
    "formRows": [
      {
        "formGroups": [
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "tdsExempted",
              "defaultValue": false,
              "displayLabel": "TDS Exempted",
              "skipLabel": true,
              "fieldInfo": {
                "dataType": "boolean"
              }
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "tdsSection",
              "displayLabel": "TDS Section",
              "placeHolder": "Enter TDS Section",
              "fieldInfo": {
                "dataType": "text"
              },
              "validators": [
                {
                    "type": "required",
                    "message": "TDS Section is required"
                }
              ]
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "tdsExemptionNo",
              "displayLabel": "TDS Exemption No",
              "placeHolder": "Enter TDS Exemption No",
              "fieldInfo": {
                "dataType": "text"
              },
              "conditions": {
                "visibility": {
                  "rules": [
                    { "field": "tdsExempted", "operator": "EQUALS", "value": true }
                  ]
                }
              },
              "validators": [
                {
                  "type": "required",
                  "message": "TDS Exemption No is required"
                }
              ]
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
                "label": "tdsValidityDate",
                "displayLabel": "TDS Validity Date",
                "placeHolder": "Enter TDS Validity Date",
                "fieldInfo": {
                    "dataType": "date"
                },
                "conditions": {
                  "visibility": {
                      "rules": [
                          { "field": "tdsExempted", "operator": "EQUALS", "value": true }
                      ]
                  }
                },
                "validators": [
                    {
                    "type": "required",
                    "message": "TDS Validity Date is required"
                    }
                ]
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "tdsNo",
              "displayLabel": "TDS No",
              "placeHolder": "Enter TDS No",
              "fieldInfo": {
                "dataType": "text"
              },
              "conditions": {
                "visibility": {
                  "rules": [
                    { "field": "tdsExempted", "operator": "EQUALS", "value": false }
                  ]
                }
              },
              "validators": [
                {
                  "type": "required",
                  "message": "TDS No is required"
                }
              ]
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
                "label": "taxRate",
                "displayLabel": "Rate of Tax",
                "placeHolder": "Enter Tax Rate",
                "fieldInfo": {
                    "dataType": "number"
                },
                "conditions": {
                  "visibility": {
                      "rules": [
                          { "field": "tdsExempted", "operator": "EQUALS", "value": false }
                      ]
                  }
                },
                "validators": [
                    {
                    "type": "required",
                    "message": "Tax Rate is required"
                    }
                ]
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "tdsLowerDeduction",
              "defaultValue": false,
              "displayLabel": "TDS Lower Deduction",
              "skipLabel": "true",
              "fieldInfo": {
                "dataType": "boolean"
              }
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
                "label": "lowerDeductionCertNo",
                "displayLabel": "Lower Deduction Certificate No.",
                "placeHolder": "Enter Certificate No.",
                "fieldInfo": {
                    "dataType": "text"
                },
                "conditions": {
                  "visibility": {
                    "rules": [
                        { "field": "tdsLowerDeduction", "operator": "EQUALS", "value": true }
                      ]
                    }
                },
                "validators": [
                    {
                    "type": "required",
                    "message": "Certificate Rate is required"
                    }
                ]
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
                "label": "lowerDeductionValidity",
                "displayLabel": "Lower Deduction Validity Date",
                "placeHolder": "Enter Validity Date",
                "fieldInfo": {
                    "dataType": "date"
                },
                "conditions": {
                  "visibility": {
                    "rules": [
                        { "field": "tdsLowerDeduction", "operator": "EQUALS", "value": true }
                      ]
                    }
                },
                "validators": [
                    {
                    "type": "required",
                    "message": "Validity Date is required"
                    }
                ]
            }
          }
        ]
      },
      {
        "formGroups": [
            {
                "style": {
                    "gridColumn": "span 3"
                },
                "control": {
                    "label": "lowerDeductionPercent",
                    "displayLabel": "Lower Deduction Percentage",
                    "placeHolder": "Enter lower deduction Rate",
                    "fieldInfo": {
                        "dataType": "number"
                    },
                    "conditions": {
                      "visibility": {
                        "rules": [
                            { "field": "tdsLowerDeduction", "operator": "EQUALS", "value": true }
                          ]
                        }
                    },
                    "validators": [
                        {
                        "type": "required",
                        "message": "Lower Deduction Rate is required"
                        }
                    ]
                }
            },
            {
                "style": {
                    "gridColumn": "span 3"
                },
                "control": {
                    "label": "lowerDeductionLimit",
                    "displayLabel": "Limit (In Rs.)",
                    "placeHolder": "Enter lower deduction limit",
                    "fieldInfo": {
                        "dataType": "number"
                    },
                    "conditions": {
                      "visibility": {
                        "rules": [
                            { "field": "tdsLowerDeduction", "operator": "EQUALS", "value": true }
                          ]
                        }
                    },
                    "validators": [
                        {
                        "type": "required",
                        "message": "Lower Deduction Limit is required"
                        }
                    ]
                }
            }
        ]
      }
    ]
}